import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

function PaymentAdd({ onPaymentAdded, userId, preselectedCustomerId }) {
  const { user } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(preselectedCustomerId || '');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [message, setMessage] = useState('');

  // Set initial date to today
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const dd = String(today.getDate()).padStart(2, '0');
    setDate(`${yyyy}-${mm}-${dd}`);
  }, []);

  useEffect(() => {
    if (preselectedCustomerId) {
      setCustomerId(preselectedCustomerId);
    }
  }, [preselectedCustomerId]);

  useEffect(() => {
    fetch(`https://www.kenan.bybello.com/backend/api/customers.php?user_id=${user.id}`, {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => setCustomers(data))
      .catch(error => console.error("Müşteriler çekilirken hata oluştu:", error));
  }, [userId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('https://www.kenan.bybello.com/backend/api/payments.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: customerId,
        amount,
        date,
        user_id: userId
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage('Ödeme başarıyla eklendi!');
          setCustomerId('');
          setAmount('');
          setDate('');
          if (onPaymentAdded) onPaymentAdded();
        } else {
          setMessage(data.error || 'Bir hata oluştu.');
        }
      })
      .catch(() => setMessage('Bir hata oluştu.'));
  };

  return (
    <div>
      <h2>Yeni Ödeme Ekle</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="customerSelect" className="form-label">Müşteri Seç</label>
          <select
            id="customerSelect"
            className="form-select"
            value={customerId}
            onChange={e => setCustomerId(e.target.value)}
            required
            disabled={!!preselectedCustomerId}
          >
            <option value="">Müşteri Seç</option>
            {customers.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="amountInput" className="form-label">Tutar</label>
          <input
            id="amountInput"
            type="number"
            className="form-control"
            placeholder="Tutar"
            value={amount}
            onChange={e => setAmount(e.target.value)}
            required
          />
        </div>
        {amount !== '' && (
          <div className="mb-3">
            <label className="form-label">Formatlı Tutar</label>
            <p className="form-control-static">{parseFloat(amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 })}</p>
          </div>
        )}
        <div className="mb-3">
          <label htmlFor="dateInput" className="form-label">Tarih</label>
          <input
            id="dateInput"
            type="date"
            className="form-control"
            value={date}
            onChange={e => setDate(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Ekle</button>
      </form>
      {message && <div className="mt-3">{message}</div>}
    </div>
  );
}

export default PaymentAdd;
